import React from "react";
import styles from "./footer.module.scss";
import { Link } from "gatsby";
import { FaPhone, FaFax, FaEnvelope } from "react-icons/fa";

const Footer = ({ siteTitle }) => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <section className={styles.logoWrap}>
          <div className={styles.logo}>
            <Link to="/">{siteTitle}</Link>
          </div>
          <p className={styles.companyInfo}>
            The easiest and most flexible way to create a community FireSmart
            plan.
          </p>
          <div className={styles.menu}>
            <Link to="/benefits">Benefits</Link>
            <Link to="/features">Features</Link>
            <Link to="https://app.firesmarthub.ca/login" target="_blank" rel="noreferrer">
              Login
            </Link>

            <a href="https://open.alberta.ca/publications/9781460146095#summary" target="_blank">Resources</a>
          </div>
        </section>

        <section className={styles.contactWrap}>
          <h6 className={styles.sectionTitle}>Contact</h6>
          <div className={styles.contact}>
            <p>
              <span className={styles.icon}>
                <FaPhone />
              </span>
              (780) 429-5873
            </p>
            <p>
              <span className={styles.icon}>
                <FaFax />
              </span>
              (780) 429-4026
            </p>
            <p>
              <span className={styles.icon}>
                <FaEnvelope />
              </span>
              <a href="mailto:contact@firesmarthub.ca">contact@firesmarthub.ca</a>
            </p>
          </div>
        </section>
      </div>

      <div className={styles.copyrightWrap}>
        <div className={styles.copyright}>
          Copyright © 2020 <a href="https://friaa.ab.ca/" target="_blank">Forest Resource Improvement Association of Alberta
          (FRIAA)</a>
        </div>
        Developed by&nbsp;
        <a href="https://www.silvacomcs.com/" target="_blank" rel="noreferrer">
          Silvacom CS
        </a>
      </div>
    </footer>
  );
};

export default Footer;
